import { render, staticRenderFns } from "./CorretivaPrincipal.vue?vue&type=template&id=78d19881&"
import script from "./CorretivaPrincipal.vue?vue&type=script&lang=js&"
export * from "./CorretivaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports